export default unmappedItems => {
    const headerTilePosition = 1;

    return unmappedItems.slice(headerTilePosition);
};
